/**
 *  ApCore JS
 *  Author: Adviva
 */

export default class AdvivaCore {
    constructor(){
        //
    }

    init(){
        window.lastScrollTop = 0;

        window.isScrollingUp = false;

        window.currentScroll = false;
    }

    /**
     * Scroll to Top
     */
    setCurrentScrollTop(){
        window.currentScroll = $(window).scrollTop();
    }

    /**
     * to TOP manager
     * @param el
     * @param offset
     */
    scrollToTopManager(el, offset=200){
        var element = $(el);
        $(window).scroll(function(){
            if (window.isScrollingUp && window.currentScroll > offset){
                // SCROLLING UP
                element.addClass('active');
            } else {
                // SCROLLING DOWN
                element.removeClass('active');
            }
        });
    }

    /**
     * Scroll To TOP
     */
    scrollToTop(){
        $(document).ready(function(){
            $('html, body').animate({
                scrollTop: 0,
            }, 1500);
        });
    }


    setScrollDirection(){
        let nowScrollTop = $(window).scrollTop();
        if (nowScrollTop > window.lastScrollTop && nowScrollTop > 0 && nowScrollTop > 1){
            // SCROLLING DOWN
            window.isScrollingUp = false;
        } else {
            // SCROLLING UP
            window.isScrollingUp = true;
        }
        window.lastScrollTop = nowScrollTop;

        return window.isScrollingUp;
    }

    /**
     *
     * @param parentRow
     * @param columnSelector
     */
    setEqualHeight(parentRow, columnSelector) {
        let tallest = 0;
        let group = $(parentRow);
        group.each(function() {
            let column = $(this).find(columnSelector);
            column.css('height', 'auto');
            tallest = 0;
            column.each(function(i,el) {
                var thisHeight = $(el).height();
                if(thisHeight > tallest) {
                    tallest = thisHeight;
                }
            });
            column.height(tallest);
        });
    }

    /*
    * Replace all SVG images with inline SVG
    */
    replaceSVGS(){
        $('.svg img, img.svg').each(function() {
            var $img = $(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                } else if ($svg.attr('viewBox') && !$svg.attr('height') && !$svg.attr('width')) {
                    let viewbox = $svg.attr('viewBox').split(" ");
                    $svg.attr('width', viewbox[2]);
                    $svg.attr('height', viewbox[3]);
                }

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        });
    }

    /**
     * Auto Scroll OnHash
     */
    autoscrollOnHash() {
        let pageHash = window.location.hash;
        if (pageHash) {
            let pageHasElement = $(pageHash);
            if (pageHasElement.length) {
                $('body').on('advivapress.window.finalize', function () {
                    $('html, body').animate({
                        scrollTop: pageHasElement.offset().top - $('#site-masthead').outerHeight(),
                    }, 1400, function(){
                        window.history.pushState("", "", window.location.origin+window.location.pathname);
                    });
                });
            }
        } if($('li.gfield_error').length > 0){
            let gfErrorElement = $('li.gfield_error');
            $('body').on('advivapress.window.finalize', function () {
                $('html, body').animate({
                    scrollTop: gfErrorElement.offset().top - $('#header-nav').outerHeight() - 15,
                });

            });
        }
    }

    /**
     * Scroll To
     *
     * @param anchor
     * @param fixedHeader
     */
    scrollToElement(anchor,fixedHeader){
        let aEl = $('#' + anchor);
        let elOffsetTop = 0;
        if(fixedHeader){
            let headerFixedH = $('#' + fixedHeader).outerHeight(true);
            elOffsetTop = (aEl.offset().top - headerFixedH);
        }else{
            elOffsetTop = aEl.offset().top;
        }
        $('html, body').animate({
            scrollTop: elOffsetTop,
        }, 1500);
    }

    /**
     * Wpml lang selector manager for WPML
     */
    toggleWpmlLangSel(){
        var subMenu = $('.ap_menu .wpml-ls-item .sub-menu');
        var wrap = $('.ap_menu .wpml-ls-item.wpml-ls-current-language');
        wrap.children('a').click(function(evt){
            evt.preventDefault();
            subMenu.slideToggle();
        });
    }

    /**
     * manage horizontal scroll for table mobile
     */
    apTableManager(){
        $('table').wrap('<div class="ap-table-wrapper"><div class="ap_container-table"></div></div>');
        $('.ap-table-wrapper').each(function (index, el) {
            if ($(this).innerWidth()< el.scrollWidth) {
                el = $(el);
                el.scrollLeft(0);
                el.append('<div class="darrow danimated dbounce"><i class="icon-chevron-right"></i></div>');
                $(window).scroll(function () {
                    var darrow_topVal = 0;
                    if ($(window).scrollTop() > el.offset().top) {
                        darrow_topVal = $(window).scrollTop() - el.offset().top + 20;
                    } else {
                        darrow_topVal = 20;
                    }
                    el.find('i').css('top', darrow_topVal + 'px');
                });
                el.scroll(function () {
                    $(this).find('.darrow').hide();
                });
            }
        });
    }

    /**
     * Gravity forms manager
     *
     */
    GformManager(){
        function isValidEmail(value){
            var re = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return value.match(re);
        }

        var fields = $('.ginput_container input, .ginput_container textarea, .ginput_container select');
        fields.each(function(i,el){
            $(el).focusin(function(){
                $(el).parents('.ginput_container').addClass('gb-focus');
                $(el).parents('.ginput_container').parent('.gfield').addClass('gb-focus');
            });
            $(el).on('keyup focusout change', function() {
                var containsRequired = $(el).parents('.gfield_contains_required');
                if(containsRequired.find('.validation_message').length === 0){
                    containsRequired.append('<div class="gfield_description validation_message"></div>');
                }

                if($(el).val()){
                    $(el).parents('.ginput_container').parent('.gfield').addClass('gb-valid').removeClass('gfield_error inline_gfield_error');
                    $(el).parents('.ginput_container').siblings('.validation_message').hide();
                    if($(el).parent('.ginput_container').hasClass('ginput_container_email') && !isValidEmail($(el).val()) && containsRequired.length > 0){
                        $(el).parents('.ginput_container').parent('.gfield').addClass('gb-valid').addClass('gfield_error inline_gfield_error');
                        $(el).parent().siblings('.validation_message').text(window.validation_text.invalidMail).show();
                    }
                } else {
                    $(el).parents('.ginput_container').parent('.gfield').removeClass('gb-valid');
                    if(containsRequired.length > 0){
                        $(el).parents('.ginput_container').parent('.gfield').addClass('gfield_error inline_gfield_error');
                        $(el).parents('.ginput_container').siblings('.validation_message').show().text(window.validation_text.empty);
                    }
                }

            });
            if ($(el).val()) {
                $(el).parents('.ginput_container').parent('.gfield').addClass('gb-valid');
            } else {
                $(el).parents('.ginput_container').parent('.gfield').removeClass('gb-valid');
            }
        });
        fields.each(function(i,el){
            $(el).focusout(function(){
                $(el).parents('.ginput_container').removeClass('gb-focus');
                $(el).parents('.ginput_container').parent('.gfield').removeClass('gb-focus');
            });
        });

        $('.ginput_container_checkbox').parent('.gfield').addClass('gfield-checkbox-group');
        $('.ginput_container_radio').parent('.gfield').addClass('gfield-radio-group');
        $('.ginput_container_textarea').parent('.gfield').addClass('container_textarea');

        let $select_sel = $('.ginput_container_select');
        let $checkbox_sel = $('.gfield_checkbox .gchoice');
        let $radio_sel = $('.gfield_radio .gchoice');

        // select style
        if($select_sel.length>0){
            $select_sel.each(function(){
                let $this = $(this);
                if(!($this.find('.gb-select-wrap').length > 0)){
                    $this.find('select').wrap('<span class="gb-select-wrap"></span>');
                }
            });
        }
        if($checkbox_sel.length>0){
            $checkbox_sel.each(function(){
                let $this = $(this);
                if(!($this.find('.gb-checkbox-style').length > 0)){
                    $this.find('input').after('<span class="gb-checkbox-style"></span>');
                }
            });
        }
        if($radio_sel.length>0){
            $radio_sel.each(function(){
                let $this = $(this);
                if(!($this.find('.gb-radio-style').length > 0)){
                    $this.find('input').after('<span class="gb-radio-style"></span>');
                }
            });
        }

        $('input.datepicker').each(function(){
            $(this).attr('autocomplete','off');
        });
    }

    /**
     * Section collapse
     *
     */
    SectionCollapse() {
        let sectionControllers = $('.mobile-section-controller');
        if(window.innerWidth < 768 && sectionControllers.length > 0) {
            sectionControllers.each(function (i, el) {
                el = $(el);
                el.addClass('closed');
                var sectionContent = $('#' + el.attr('id').replace("-controller", ""));
                if (sectionContent.hasClass('opened')) {
                    sectionContent.css('height', 'auto');
                } else {
                    sectionContent.addClass('closed');
                }
                el.click(function (e) {
                    e.preventDefault();
                    el = $(this);
                    var sectionId = el.attr('id');
                    toggleMobileSection(sectionId);
                });
            });
        }
    }

    ApSetCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        var path = ";path=/";
        document.cookie = cname + "=" + cvalue + "; " + expires + path;
    }

    ApGetCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    }
}

/**
 * IS IN VIEWPORT
 * @returns {boolean}
 */
$.fn.isInViewport = function () {
    let response = false;
    if(typeof $(this).offset() !== "undefined"){
        let elementTop = $(this).offset().top;
        let elementBottom = elementTop + $(this).outerHeight();
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();
        response = (elementBottom > viewportTop && elementTop < viewportBottom);
    }
    return response;
};


// SmartResize Method
(function($,sr){
    var debounce = function (func, threshold, execAsap) {
        var timeout;
        return function debounced () {
            var obj = this, args = arguments;
            function delayed () {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            }

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 150);
        };
    };
    jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
})(jQuery,'smartresize');


function toggleMobileSection(sectionControllerId) {
    var sectionController = $('#' + sectionControllerId);
    var sectionContent = $('#' + sectionControllerId.replace("-controller", ""));
    var curH = sectionContent.height();
    if (curH === 0) {
        openMobileSection(sectionContent);
        sectionController.addClass('opened');
        sectionController.removeClass('closed');
    } else {
        closeMobileSection(sectionContent);
        sectionController.addClass('closed');
        sectionController.removeClass('opened');
    }
}

function openMobileSection(el) {
    var element = $(el);
    element.addClass('opened');
    element.removeClass('closed');
    var curHeight = element.height();
    var autoHeight = element.css('height', 'auto').height();
    element.height(curHeight).animate({height: autoHeight}, 500, function () {
        element.css('height', 'auto');
    });
}

function closeMobileSection(el) {
    var element = $(el);
    element.addClass('closed');
    element.removeClass('opened');
    element.animate({height: 0}, 500);
}



// WEBPACK FOOTER //
// ./scripts/libs/advivapress.js